export default "__VITE_ASSET__BV107Uzk__"